/** Scooter + package illustration (Figma Shipping type). */
export const COURIER_DELIVERY_ILLUSTRATION_SRC = "/images/shiping.png";

/** Scooter + lightning bolt illustration (Figma express availability modal). */
export const COURIER_EXPRESS_AVAILABILITY_ILLUSTRATION_SRC =
	"/images/courier-express-availability.png";
